import { AgGridReact } from "ag-grid-react";
import { React, useRef, useMemo, useCallback } from "react";
import './WrappedAgTable.css';
import { Button } from "react-bootstrap";
import { Children } from 'react';

// LicenseManager.setLicenseKey("Using_this_AG_Grid_Enterprise_key_( AG-040678 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Administradora Mall Aventura S.A.C. )_is_granted_a_( Single Application )_Developer_License_for_the_application_( Mall Aventura - Portal )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( Mall Aventura - Portal )_need_to_be_licensed___( Mall Aventura - Portal )_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_AG_Grid_Enterprise_versions_released before_( 4 April 2024 )____[v2]_MTcxMjE4NTIwMDAwMA==ce13f7f5415cfa2c4d86d1e48d2e08de")

export default function WrappedAgTable({ titleExcel = 'Report', showButtonExport = true, children, ...agGridCustomValues }) {

  const gridRef = useRef();
  const resultChildrens = Children.toArray(children);
  const defaultColDef = useMemo(() => {
    return {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 90,
      flex: 1,
      floatingFilter: true,
      enableRowGroup: false
    }
  }, [])

  const sidebar = useMemo(() => {
    return {
      toolPanels: [
        {
          id: 'columns',
          labelDefault: 'Columns',
          labelKey: 'columns',
          iconKey: 'columns',
          toolPanel: 'agColumnsToolPanel',
          toolPanelParams: {
            enableRowGroup: false,
            suppressPivotMode: true,
            suppressValues: true,
            suppressRowGroups: true
          },
        }
      ],
      defaultToolPanel: '',
    }
  }, [])

  //TODO: Review: https://www.ag-grid.com/javascript-data-grid/excel-export-data-types/
  const excelStylesGrid = useMemo(() => [
    {
      id: 'date',
      dataType: 'DateTime',
      numberFormat: {
        format: 'dd/mm/yyyy'
      }
    },
  ], [])

  const agGridDefaultValues = {
    ref: gridRef,
    domLayout: 'autoHeight',
    defaultColDef: defaultColDef,
    //rowHeight: 40,//Se controla desde el estilo. View WrappedAgTable.css
    alwaysShowHorizontalScroll: true,
    alwaysShowVerticalScroll: true,
    colResizeDefault: 'shift',
    suppressSizeToFit: true,
    pagination: true,
    paginationPageSize: 10,
    rowDragManaged: true,
    animateRows: true,
    sideBar: sidebar,
    localeText: {
      rowGroupColumnsEmptyMessage: "Arrastre aquí para establecer grupos de filas",
      filterOoo: 'Filtrar...',
      equals: 'Es igual',
      notEqual: 'No es igual',
      blank: 'En Blanco',
      notBlank: 'No en blanco',
      empty: 'Elige uno',
      lessThan: 'Menor que',
      greaterThan: 'Mayor que',
      lessThanOrEqual: 'Menor o igual a',
      greaterThanOrEqual: 'Mayor o igual a',
      inRange: 'En rango',
      inRangeStart: 'Desde',
      inRangeEnd: 'Hasta',
      contains: 'Contiene',
      notContains: 'No contiene',
      startsWith: 'Empieza con',
      endsWith: 'Termina con',
      andCondition: 'Y',
      orCondition: 'O',
      pinColumn: 'Fijar columna',
      pinLeft: 'Fijar a la izquierda',
      pinRight: 'Fijar a la derecha',
      noPin: 'No fijar',
      valueAggregation: 'Agregación de valores',
      noAggregation: 'Ninguna',
      autosizeThiscolumn: 'Ajustar automáticamente esta columna',
      autosizeAllColumns: 'Ajustar automáticamente todas las columnas',
      groupBy: 'Agrupar por',
      ungroupBy: 'Desagrupar',
      ungroupAll: 'Desagrupar todo',
      columns: 'Columnas',
      filters: 'Filtros',
      resetColumns: 'Restablecer columnas',
      to: 'a',
      of: 'de',
      page: 'Página',
      nextPage: 'Siguiente Página',
      lastPage: 'Última Página',
      firstPage: 'Primera Página',
      previousPage: 'Página Anterior',
      selectAll: '(Seleccionar todo)',
      selectAllSearchResults: '(Seleccionar todos los resultados de búsqueda)',
      searchOoo: 'Buscar...',
      blanks: '(Espacios en blanco)',
      noMatches: 'Sin coincidencias',
      loadingOoo: 'Cargando...',
      loadingError: 'ERROR',
      noRowsToShow: 'No hay filas para mostrar',
      enabled: 'Habilitado',
      copy: 'Copiar',
      copyWithHeaders: 'Copiar con Encabezados',
      copyWithGroupHeaders: 'Copiar con Encabezados de Grupo',
      cut: 'Cortar',
      paste: 'Pegar',
      export: 'Exportar',
      csvExport: 'Exportar CSV',
      excelExport: 'Exportar Excel',
      //dateFormatOoo: 'DD-MM-YYYY'
    },
    excelStyles: excelStylesGrid,
    overlayLoadingTemplate:
      `<span class="ag-overlay-loading-center d-flex align-items-center">
                <div class="spinner-border text-primary me-3" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
                Cargando información ...
            </span>`,
    overlayNoRowsTemplate:
      `<span class="ag-overlay-loading-center d-flex align-items-center">
            <i class="fi fi-rr-sad-tear fs-1 me-3"></i>
            No se encontraron registros
        </span>`,
  };

  const getRows = useCallback(() => [
    {
      cells: [
        { data: { value: titleExcel, type: 'String' }, mergeAcross: agGridCustomValues.columnDefs.length - 1 },
      ],
    },
  ], [titleExcel, agGridCustomValues.columnDefs]);

  const onBtnExport = useCallback(() => {
    gridRef.current.api.exportDataAsExcel({
      prependContent: getRows(),
      fileName: titleExcel + ".xlsx",
      sheetName: "data",
      author: "Mall Aventura Digital"
    });
  }, [gridRef, getRows, titleExcel]);

  const containerStyle = useMemo(() => ({ width: '100%', height: 'calc(100% - 40px)' }), []);
  const gridStyle = useMemo(() => ({ height: 'calc(100% - 20px)', width: '100%' }), []);


  const onFilterTextBoxChanged = useCallback((event) => {
    console.info(event, "event!!!");
    gridRef.current.api.setQuickFilter(event.target.value);
  }, []);


  return (
    <>
      <div className="row mb-2 g-2">
        <div className="col-12 col-sm-6">
          <div className="input-group input-group-sm input-group-search">
            <i className="fi fi-rr-search form-control-icon"></i>
            <input type="text" className="form-control" placeholder="Buscar" onInput={onFilterTextBoxChanged} ></input>
          </div>
        </div>
        <div className="col-12 col-sm-6 d-flex justify-content-end">
          {showButtonExport && (
            <Button variant="primary" size="sm" onClick={onBtnExport}>
              <i className="fi-rr-download"></i> Descargar
            </Button>
          )}
          {resultChildrens[0]}
        </div>
      </div>
      {resultChildrens[1] && <div className="row mb-2 g-2">
        {resultChildrens[1]}
      </div>}
      
      <div className="table-responsive" style={containerStyle}>
        <div id="myGrida" className="ag-theme-balham" style={gridStyle}>
          <AgGridReact
            {...agGridDefaultValues}
            {...agGridCustomValues}
          />
        </div>
      </div>
    </>
  )
}
